import Vue from 'vue';
import Vuex from 'vuex';

/** Global store */
import app from '@/store/config.store';
import auth from '@/store/auth.store';

import article from '@/store/article.store';

/** Achat store */
import chat from '@/store/achat/chat.store';
import noteFrais from '@/store/achat/note_frais.store';
import eb from '@/store/achat/expression_besoin.store';
import dmdAchat from '@/store/achat/demande.store';
import abonnement from '@/store/achat/abonnement.store';
import sourcing from '@/store/achat/sourcing.store';
import tiers from '@/store/tiers.store';
import tiersContact from '@/store/tiers-contact.store';
import tiersConnaissance from '@/store/tiers-connaissance.store';

/** GPAO store */
import of from '@/store/gpao/of.store';

/** RH store */
import offreEmploi from '@/store/rh/offre-emploi.store';
import candidature from '@/store/rh/candidature.store';
import employe from '@/store/rh/employe.store';
import formation from '@/store/rh/formation.store';
import formationSession from '@/store/rh/formation-session.store';
import profilParticipant from '@/store/rh/profil-participant.store';

import checklist from '@/store/rh/checklist.store';
import entretien from '@/store/rh/entretien.store';

/** CRM store */
import mission from '@/store/crm/mission.store';
import tache from '@/store/crm/mission_tache/tache.store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    /** Global */
    app,
    auth,
    /**Achat */
    article,
    noteFrais,
    eb,
    dmdAchat,
    chat,
    abonnement,
    sourcing,

    /** CRM */
    mission,
    tache,

    /** GPAO */
    of,

    /** Tiers */
    tiers,
    tiersContact,
    tiersConnaissance,

    /** RH */
    offreEmploi,
    candidature,
    employe,
    formation,
    formationSession,
    profilParticipant,
    checklist,
    entretien,
  },
});
